export default ({ redirect, req }) => {
  if (!req) {
    return true;
  }
  const defaultTab = '/icerikler';
  const reqUrl = req?._parsedUrl?.pathname || req?.url || '';

  if (reqUrl.includes(defaultTab)) {
    redirect(301, reqUrl.replace(defaultTab, ''));
  } else {
    return true;
  }
};
